import { Button, Spacer, Text } from '@chakra-ui/react';
import {
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';
import { capitalize } from 'lodash-es';

import { GardenVnoAllocationInfo } from '../GardenVnoAllocationInfo';
import { useGardenHarvestDrawer } from './useGardenHarvestDrawer';

export const SuccessContent = () => {
  const t = useTranslations();

  const onClose = useGardenHarvestDrawer((s) => s.onClose);
  const vaultType = useGardenHarvestDrawer((s) => s.vaultType);
  const harvestAmount = useGardenHarvestDrawer((s) => s.harvestAmount);

  return (
    <>
      <ModalOrDrawerBody alignItems="center">
        <Text textStyle="h3" textAlign="center">
          {t('Transaction completed!')}
        </Text>
        <Spacer my="24px" />
        <GardenVnoAllocationInfo
          vnoAmountTitle={t('You have successfully harvested')}
          vnoAmount={harvestAmount}
          allocationTitle={
            <Text w="full" textStyle="body" textAlign="center">
              {t('{coin} allocation', {
                coin: 'VNO',
              })}
            </Text>
          }
          intoWalletTitle={t('Into your wallet')}
          into12MonthTitle={t('In 12 month {vault}', {
            vault: capitalize(vaultType || ''),
          })}
        />
      </ModalOrDrawerBody>
      <ModalOrDrawerFooter>
        <Button onClick={onClose}>{t('Done')}</Button>
      </ModalOrDrawerFooter>
    </>
  );
};
